import React from 'react'
import Icon from '@ant-design/icons'

const HomeSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor">
    <path d="M18 18H10V12H18V18ZM8 18H0V8H8V18ZM18 10H10V0H18V10ZM8 6H0V0H8V6Z"/>
  </svg>
)

const HomeIcon = props => <Icon component={HomeSvg} {...props} />

export default HomeIcon